module.exports = __webpack_public_path__ + "img/sozialschnellgut_6_b.7f2068fb.jpg";